import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useCallback } from 'react';

const actions = [
  // general
  'Open',
  'Close',
  'Resize',
  'Switch tab',
  'Change product',
  'Download spreadsheet',
  'Filter: only my deals',
  'Filter: daterange modified',
  // Cash tab
  'Change cash grid sort',
  'Apply cash grid filter',
  'Show cash grid column',
  'Hide cash grid column',
  'Resize cash grid column',
  'Move cash grid column via column header',
  'Move cash grid column via tool panel',
  'Open cash grid sidebar',
  'Close cash grid sidebar',
  'Show cash detail',
  'Hide cash detail',
  'Open cash in Xone',
  'Reprice quote for cash',
  // Order tab
  'Change order grid sort',
  'Apply order grid filter',
  'Show order grid column',
  'Hide order grid column',
  'Resize order grid column',
  'Move order grid column via column header',
  'Move order grid column via tool panel',
  'Open order grid sidebar',
  'Close order grid sidebar',
  'Order action',
  // option tab
  'Change option grid sort',
  'Apply option grid filter',
  'Show option grid column',
  'Hide option grid column',
  'Resize option grid column',
  'Move option grid column via column header',
  'Move option grid column via tool panel',
  'Open option grid sidebar',
  'Close option grid sidebar',
  'Show option detail',
  'Hide option detail',
  'Open option in Xone',
  'Reprice quote for option',
  // accumulator tab
  'Change accumulator grid sort',
  'Apply accumulator grid filter',
  'Show accumulator grid column',
  'Hide accumulator grid column',
  'Resize accumulator grid column',
  'Move accumulator grid column via column header',
  'Move accumulator grid column via tool panel',
  'Open accumulator grid sidebar',
  'Close accumulator grid sidebar',
  'Show accumulator detail',
  'Hide accumulator detail',
  'Open accumulator in Xone',
] as const;

type TrackEventAction = (typeof actions)[number];

export function useTrackEvent() {
  const { sgwtWebAnalytics } = useSgwtWidgets();

  return useCallback(
    (action: TrackEventAction, value?: string) => sgwtWebAnalytics?.trackEvent('Blotter', action, value),
    [sgwtWebAnalytics],
  );
}
